// 积分获取 PointsAcquisition
export default function PointsAcquisition() {
    return <div>PointsAcquisition</div>;
}
